import { useSearchParams } from 'react-router-dom';

/*
 * Custom hook for managing URL parameters in a JSON structure
 */
export function useUrlParams() {
    const [searchParams, setSearchParams] = useSearchParams();

    // Parse parameters from URL
    const getParamsObject = () => {
        const params = {};

        searchParams.forEach((value, key) => {
            // Non-JSON params (e.g. the raw ?session= id) are not report params — skip them.
            try {
                params[key] = JSON.parse(value);
            } catch (err) {
                // ignore
            }
        });

        return params;
    };

    // Update URL parameters by merging with existing ones. The functional update keeps
    // this safe to call from stale closures and preserves params written by other hooks.
    const setParamsObject = params => {
        setSearchParams(prev => {
            const next = new URLSearchParams(prev);
            Object.entries(params).forEach(([key, value]) => {
                next.set(key, JSON.stringify(value));
            });
            return next;
        });
    };

    const removeParam = param => {
        const newParams = new URLSearchParams(searchParams);
        newParams.delete(param);
        setSearchParams(newParams);
    };

    return {
        getParamsObject,
        setParamsObject,
        removeParam,
    };
}
